// Static Text is effectively just a label, so this component
// effectively does nothing at this point. Creating it as a placeholder
// in case we ever change that.
import { withDependentReferenceDataCustomField } from "../../lib/customHooks/useReferenceData";
export const StaticTextPreview = withDependentReferenceDataCustomField('label')(({
  default: defaultValue,
  value = defaultValue,
  label
}) => <label className="label--pre-formatted">{value || label}</label>);